module.exports = new __parcel__URL__("error.e4b20277.svg").toString();